import React, { useEffect } from 'react';
import { SignupForm } from '../../toolympus/components/auth';
import { SignupMode, useSignup } from '../../toolympus/hooks/auth';
import { PublicPageWrapper } from '../Common/PublicPageWrapper';
import { useLocale } from '../../toolympus/components/localization/LocalizationProvider';
import { PseudoLink2 } from '../../toolympus/components/primitives';

export const PublicPageLangSwitch = (props: { noMargin?: boolean }) => {
  const { locale, setLocale } = useLocale();

  return (
    <PseudoLink2
      className="lang-switch"
      style={{ marginTop: props.noMargin ? 0 : "1rem", fontSize: "0.9rem" }}
      onClick={() => setLocale(locale === "ru" ? "en" : "ru")}>
      {locale === "ru" ? "EN" : "RU"}
    </PseudoLink2>
  )
}

export const SignupContainer = () => {
    const mode = SignupMode.Common;
    const signupData = useSignup({ signupApiPath: "/api/signup", mode: mode });

    return (
        <PublicPageWrapper>
          <SignupForm
              signupData={signupData}
              mode={mode}
              />
          <PublicPageLangSwitch />
        </PublicPageWrapper>
    );
}

export const SignupContainerForceEn = () => {
  const localization = useLocale();

  useEffect(() => {
    localization.setLocale("en");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SignupContainer />
  );
}